var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkillsProductpackging(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 41.346,
    viewBox: "0 0 46 41.346",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "skills_productpackging",
    d: "M53.783-5078.654A3.787,3.787,0,0,1,50-5082.436v-21.124a1.3,1.3,0,0,1,.167-.636l5.615-9.978v-4.531a1.3,1.3,0,0,1,1.3-1.3H71.439a1.3,1.3,0,0,1,1.3,1.3v4.5l4.762,10.089a1.28,1.28,0,0,1,.125.552v21.124a3.787,3.787,0,0,1-3.783,3.782Zm14.224-2.592h5.831a1.194,1.194,0,0,0,1.192-1.191v-19.869H68.007Zm-12.079-14.9h5.78v-2.592h-5.78Zm-2.4-8.75H65.825l3.576-7.7H57.866Zm4.839-10.309H70.144v-2.2H58.373Zm25.668,36.55a3.091,3.091,0,0,1-3.086-3.086v-14.683a1.313,1.313,0,0,1,.051-.366l2.326-7.906v-3.552a1.3,1.3,0,0,1,1.3-1.295h7.7a1.294,1.294,0,0,1,1.3,1.295v3.552l2.326,7.906a1.268,1.268,0,0,1,.053.366v14.683a3.092,3.092,0,0,1-3.088,3.086Zm-.059-19.065h8.992l-1.628-5.532H85.609Zm1.942-8.122h5.108v-1.111H85.923Z",
    transform: "translate(-50 5120)",
    fill: "#5637fa"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillsProductpackging);
export default __webpack_public_path__ + "static/media/skills_productpackging.a455e5a46478bed789a54cb9c7991f6a.svg";
export { ForwardRef as ReactComponent };